/**
 * The record designer page: the one `Designer` component, fed by the record source.
 *
 * Everything that used to live here — the process rail, the sequence, the inspector, the
 * floating rail — is `@/designer/Designer`, which the operation-type page mounts too. This
 * file binds it to a record and nothing more.
 */
import React, { useMemo } from "react";

import Designer from "@/designer/Designer";
import { recordSource } from "./recordSource";

export default function RecordDesigner({ recipeId }) {
  const source = useMemo(() => recordSource(recipeId), [recipeId]);
  return <Designer source={source} />;
}
